import { ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { RecommendationCard } from '../../../app/spaces/CardView/RecommendationCard';

export const RecommendedViewDefinition: ExplorableItemDefinition = {
  itemType: 'recommendedView',
  pluralName: Messages.recommendations,
  emptyStateMessage: Messages.recommendationsEmptyMessage,
  contentFilterKeys: null,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: RecommendationCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => null,
  getContentInfo: () => {
  },
  supportedDisplayModes: ['thumbnail'],
};
